import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { config } from "config";
import { SelectOption } from "components/atoms/Select";

const default_page_size = config.PAGE_SIZE;

interface CsvMessage {
  message: string;
  type: "success" | "error" | "warning" | "info";
}

interface InsuranceState {
  carInsurance: any | null;
  carsInsurance: any[];
  loading: boolean;
  exportCSVLoading: boolean;
  csvMessage: CsvMessage | null; // Update this to reflect the correct structure
  current_filters: any;
  filters: { page: number; pageSize: number };
  refresh: number;
  refreshLoader: boolean;
  totalCount: number;
}

const initialState: InsuranceState = {
  carInsurance: null,
  carsInsurance: [],
  loading: false,
  exportCSVLoading: false,
  csvMessage: null,
  current_filters: {},
  filters: { page: 1, pageSize: default_page_size },
  refresh: 0,
  refreshLoader: false,
  totalCount: 0,
};

export const deliveryCarInsuranceSlice = createSlice({
  name: "deliveryCarInsurance",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCarInsurance: (state, action: PayloadAction<any>) => {
      state.carInsurance = action.payload;
    },
    setCarsInsurance: (state, action: PayloadAction<any[]>) => {
      state.carsInsurance = action.payload;
    },
    setTotalCount: (state, action: PayloadAction<{ totalCount: number }>) => {
      const { totalCount } = action.payload;
      state.totalCount = totalCount;
    },
    updateInsurance: (state, action) => {
			const { id, insurance } = action.payload;
			state.carsInsurance.every(({ _id }, i) => {
				if (id === _id) {
					state.carsInsurance[i] = insurance;
					return false;
				}
				return true;
			});
		},

  },
});

const deliveryCarInsuranceReducer = deliveryCarInsuranceSlice.reducer;

export const deliveryCarInsuranceActions = deliveryCarInsuranceSlice.actions;
export default deliveryCarInsuranceReducer;
